<template src="./ButtonNextComponent.html"></template>
<script>
export default {
  name: 'ButtonNextComponent',
  props: {
    label: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss">
  .btn-next {
    color: #696cff;
    border-color: #696cff;
    background: transparent;
    width: 120px;
  }
  .btn-next:hover {
  	color: #fff;
    background-color: #696cff;
    border-color: #696cff;
    box-shadow: 0 0.125rem 0.25rem 0 rgba(113, 221, 55, 0.4);
    transform: translateY(-1px);
  }
</style>
